import { ACTIVE, INACTIVE, NEEDS_REVIEW } from 'AccountsApp/ts/constants/integrations.constants';
import { BlackDiamondIntegrationService } from 'IntegrationsApp/ts/services/black-diamond-integration-service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/black-diamond-integration-service";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i3 from "NewAngular/features/directives/image/image.directive";
import * as i4 from "../integration-status-indicator/integration-status-indicator.component";
const _c0 = ["blackDiamondDeactivateModalComponent"];
const _c1 = ["blackDiamondActivateModalComponent"];
const _c2 = ["ycn-black-diamond-integration-list-item", ""];
export class BlackDiamondIntegrationListItemComponent {
    constructor(blackDiamondIntegrationService) {
        this.blackDiamondIntegrationService = blackDiamondIntegrationService;
        this.status = '';
        this.errorMessage = '';
        this.innerHtml = '<p><strong>To connect your Black Diamond integration to YCharts, log in to your Black Diamond account.</strong></p>\n' +
            '<p>Once you log into your Black Diamond account from this portal, you’ll return to YCharts and be able to import holdings from Black Diamond.</p>';
    }
    ngOnInit() {
        this.updateStatus();
    }
    updateStatus() {
        this.blackDiamondIntegrationService.getBlackDiamondIntegrationStatus().subscribe({
            next: (data) => {
                if (data.isActive) {
                    this.status = ACTIVE;
                }
                else if (!data.isActive && data.errorMessage === null) {
                    this.status = INACTIVE;
                }
                else if (!data.isActive && data.errorMessage !== null) {
                    this.status = NEEDS_REVIEW;
                    this.errorMessage = data.errorMessage;
                }
            },
            error: () => { },
        });
    }
    activateHandler(confirmed) {
        if (confirmed) {
            window.location.href = `${this.authUrl}?response_type=code&redirect_uri=${this.redirectUri}&client_id=${this.clientId}&scope=offline_access+api`;
        }
        else {
            this.status = INACTIVE;
        }
    }
    deactivateHandler(confirmed) {
        if (confirmed) {
            this.blackDiamondIntegrationService
                .deactivateBlackDiamondIntegration()
                .subscribe((res) => {
                if (res.status === 200) {
                    this.updateStatus();
                }
            });
        }
    }
    activateToggle() {
        if (this.status === ACTIVE) {
            this.blackDiamondDeactivateModalComponent.openModal();
        }
        else {
            this.status = ACTIVE;
            this.blackDiamondActivateModalComponent.openModal();
        }
    }
}
BlackDiamondIntegrationListItemComponent.ɵfac = function BlackDiamondIntegrationListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BlackDiamondIntegrationListItemComponent)(i0.ɵɵdirectiveInject(i1.BlackDiamondIntegrationService)); };
BlackDiamondIntegrationListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BlackDiamondIntegrationListItemComponent, selectors: [["tr", "ycn-black-diamond-integration-list-item", ""]], viewQuery: function BlackDiamondIntegrationListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.blackDiamondDeactivateModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.blackDiamondActivateModalComponent = _t.first);
    } }, inputs: { clientId: "clientId", authUrl: "authUrl", redirectUri: "redirectUri" }, standalone: false, attrs: _c2, decls: 17, vars: 10, consts: [["blackDiamondActivateModalComponent", ""], ["blackDiamondDeactivateModalComponent", ""], [1, "table-logo"], ["ycnImage", "", 3, "imageSrc"], [1, "text-bold"], [3, "errorMessage", "status"], [1, "text-right"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"]], template: function BlackDiamondIntegrationListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "td")(1, "div", 2);
        i0.ɵɵelement(2, "img", 3);
        i0.ɵɵelementStart(3, "div", 4);
        i0.ɵɵtext(4, "Black Diamond");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6, "Portfolio Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "td");
        i0.ɵɵelement(8, "ycn-integration-status-indicator", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "td", 6)(10, "label", 7)(11, "input", 8);
        i0.ɵɵlistener("change", function BlackDiamondIntegrationListItemComponent_Template_input_change_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateToggle()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "span", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-confirm-modal", 10, 0);
        i0.ɵɵlistener("confirmHandler", function BlackDiamondIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_13_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "ycn-confirm-modal", 10, 1);
        i0.ɵɵlistener("confirmHandler", function BlackDiamondIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.deactivateHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("imageSrc", "integrations/images/black-diamond-logo.png");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("errorMessage", ctx.errorMessage)("status", ctx.status);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.status === "active");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Log in to Black Diamond")("confirmHeader", "Activate Black Diamond Integration")("confirmText", ctx.innerHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Deactivate")("confirmHeader", "Deactivate Black Diamond Integration")("confirmText", "Are you sure you would like to deactivate your integration with Black Diamond? You will not be able to use this integration unless you reactivate it.");
    } }, dependencies: [i2.ConfirmModalComponent, i3.ImageDirective, i4.IntegrationStatusIndicatorComponent], encapsulation: 2 });
